export interface AppEvents {  
  "connected":() =>void;
  "game_loaded":(url:string)=>void;
  "join_room_clicked":()=>void;
  "room_ready":()=>void;
  "menu_event":()=>void
  "role_recieved":()=>void;
}

export interface ControllerTypeData {
  role: number; // 1 = PRIMARY, 2 = SECONDARY
  index: number;
}

export interface ControllerInitData {
  clientId: string;
  roomId: string;
}

export interface RoomJoinData {
  clientId: string;
  roomId: string;
}

export class EventBus<E> {
  private listeners: { [K in keyof E]?: ((data: E[K]) => void)[] } = {};

  public subscribe<K extends keyof E>(event: K, listener: (data: E[K]) => void): void {
      if (!this.listeners[event]) {
          this.listeners[event] = [];
      }
      this.listeners[event]?.push(listener);
  }

  public publish<K extends keyof E>(event: K, data: E[K]): void {
      this.listeners[event]?.forEach(listener => listener(data));
  }
}
